import React from "react";
import Nav from "./Nav";
import Footer from "./Footer";

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-black text-gray-200 font-body">
      <Nav />
      <main className="pt-20">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
